#import "../../../core-entity/graphql/fragments/contact-for-core-entity-fragment.graphql"
#import "../../../core-entity/graphql/fragments/account-for-core-entity-fragment.graphql"

mutation CreatePeepMap($input: PeepMapCreateInput!) {
    peepMapCreate(input: $input) {
        contact {
            ...ContactForCoreEntityFragment
        }
        account {
            ...AccountForCoreEntityFragment
        }
    }
}
